import PhoneInput from './styled';

export default PhoneInput;
